// ============================================================================
// page-service-single / other-services.js
// ----------------------------------------------------------------------------
// "Other Services" — left-aligned Flickity strip of sibling service cards.
// No external prev/next on this one; the strip is draggable only.
// ============================================================================

import { initCarousels } from "../carousel";

document.addEventListener("DOMContentLoaded", function () {
  const sliderEl = document.querySelector(".service-other__card");
  if (!sliderEl) return;

  sliderEl.style.display = "block";

  initCarousels(".service-other__card", {
    cellAlign: "left",
    contain: true,
    pageDots: false,
    wrapAround: false,
    imagesLoaded: true,
  });
});
